export default [
  {
    path: '/proyectos',
    name: 'objetivo-proyecto',
    component: () => import('@/views/seguimientop/Proyecto/Proyecto.vue'),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/objetivos',
    name: 'list-objetivo',
    component: () => import('@/views/seguimientop/Objetivo/Objetivo.vue'),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/objetivo-detalle/:id',
    name: 'objetivo-detalle',
    component: () => import('@/views/seguimientop/ObjetivoDetalle/ObjetivoDetalle.vue'),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
  {
    path: '/medida-detalle/:id',
    name: 'medida-detalle',
    component: () => import('@/views/seguimientop/Medida/Medida.vue'),
    meta: {
      contentClass: 'ecommerce-application',
    },
  },
]
